<template v-if="webstoreContent">
    <div>
        <loading-overlay :active.sync="displayLoader" id="loader" loader="dots" color="#1A74DB" height="30" width="100%" opacity="0.85">
        </loading-overlay>
        <div class="text-left product-listing" @click="setActiveProduct(); viewProduct(productKey)">
            <img :src="productInfo.image">
            <h3 class="product-name">{{ productInfo.name }}</h3>
            <template v-if="!hidePriceListingForVG && shouldCustomerSeePricing && (!isENT || ((defaultOffer && defaultOffer.monthlyUnitPrice) || (productKey.includes('CBL'))))">
                <template>
                    <template v-if="calculatedSalesPrice !== calculatedListPrice">
                        <span :class="smallFleetOpportunity && isAccountCreatedAfterTitan ? 'small-fleet-list-price': 'default-offer-list-price'">
                            {{ currencySymbol.toUpperCase() }}{{ calculatedListPrice.toLocaleString('en-US') }}
                        </span>
                        <span :class="smallFleetOpportunity && isAccountCreatedAfterTitan ? 'small-fleet-sale-price': 'default-offer-sales-price'">
                            {{ currencySymbol.toUpperCase() }}{{ calculatedSalesPrice.toLocaleString('en-US') }} {{currencyIsoCode}}{{paymentTerm ? `/${paymentTerm}` : ''}}
                        </span>
                    </template>
                    <template v-else>
                        <span :class="smallFleetOpportunity && isAccountCreatedAfterTitan ? 'small-fleet-sale-price': 'default-offer-sales-price'">
                            {{ currencySymbol.toUpperCase() }}{{ calculatedSalesPrice.toLocaleString('en-US') }} {{currencyIsoCode}}{{paymentTerm ? `/${paymentTerm}` : ''}}
                        </span>
                    </template>
                    <br/>
                    <span class ="small-fleet-payment-terms" v-if="smallFleetOpportunity && defaultOffer.offerKey.toLowerCase().includes('license')">due at checkout for 3 year license</span>
                </template>
            </template>
            <p class="product-brief">{{ productInfo.brief }}</p>
            <div class="flex justify-center md:justify-start mt-1/2 items-center">
                <a
                    v-if="showProductDetails"
                    class="view-product"
                    @click="setActiveProduct(false); viewProduct(productKey);"
                >
                    {{ webstoreContent.viewProduct }}
                </a>
                <span
                    v-if="!hidePriceListingForVG && shouldCustomerSeePricing && (!isENT || ((defaultOffer && defaultOffer.monthlyUnitPrice) || productKey.includes('CBL')))"
                    class="buy-product"
                    @click="handleBuyButtonClick"
                >
                    {{ webstoreContent.webstoreBody.product_nav.buy }}
                </span>
                <span v-else @click.stop="handleInquireButtonClick" class="buy-product">
                    {{ webstoreContent.webstoreBody.product_nav.inquire }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex';
    import product from '../../../store/modules/product/index';
    import { analyticsTrack } from '../../../plugins/segment';
    import { coreProducts, productsWithLicenses } from '../../../settings';
    import { WebstoreResources } from '../../../mixins/webstore-resources';
    import SalesforceResources from '../../../mixins/salesforce-resources';
    import SegmentResources from '../../../mixins/segment-resources';

    export default {
        mixins: [
            WebstoreResources,
            SalesforceResources,
            SegmentResources,
        ],
        props: ['productFamily', 'productKey', 'productInfo', 'webstoreContent'],
        data() {
            return {
                defaultOfferStart: this.productInfo.offerings[this.productInfo.defaultOffering],
                coreProducts: coreProducts,
                productsWithLicenses: productsWithLicenses,
                displayLoader: false
            }
        },

        computed: {
            ...mapGetters([
                'activeProductKey',
                'currencySymbol',
                'isAccountCreatedAfterTitan',
                'anonymousLargeFleet',
                'pricingModalComplete',
                'isAnonymousCustomer',
                'isPartnerAccount',
                'isVGBasicCustomer'
            ]),

            ...mapGetters('content', [
                'webstoreContent'
            ]),

            ...mapGetters('checkout', [
                'currencyIsoCode',
                'smallFleetOpportunity',
                'isENT'
            ]),

            // These functions take the lists of separate prices and combine them into on value to show
            salesPriceLocal() {
                let total = 0
                this.defaultOffer && typeof(this.defaultOffer.salesPrice) !== 'number' ? this.defaultOffer.salesPrice.forEach((value) => total += value.price): total+= this.defaultOffer.salesPrice;
                return total
            },

            listPriceLocal() {
                let total = 0
                this.defaultOffer && typeof(this.defaultOffer.listPrice) !== 'number' ? this.defaultOffer.listPrice.forEach((value) => total += value.price): total+= this.defaultOffer.listPrice;
                return total
            },

            showProductDetails() {
                if (this.coreProducts.includes(this.productKey)) {
                    return true;
                } else if (this.isENT && this.productsWithLicenses.includes(this.productKey) && !(this.defaultOffer && this.defaultOffer.monthlyUnitPrice)) {
                    return true
                } 
                return false;
            },

            defaultOffer() {
                if(this.productInfo.key.includes("CM") && !this.productInfo.key.includes("ACC") && this.isPartnerAccount){
                    return this.productInfo.offerings["License + Hardware"]
                }
                let licenseOfferings = Object.values(this.productInfo.offerings).filter((offering) => (offering.offerKey.includes("License + Hardware") && !offering.offerKey.includes("Add-on")))
                if (licenseOfferings.length > 1) {
                    return licenseOfferings.reduce((min, offering) => min.listPrice < offering.listPrice ? min : offering)
                } else {
                    return this.defaultOfferStart
                }
            },
            
            paymentTerm() {
                if (!this.smallFleetOpportunity) {
                    if (this.isENT && !this.isPartnerAccount && this.defaultOffer.offerKey.includes("License")) {
                        return 'month'
                    } else {
                        return this.defaultOffer && this.defaultOffer.offerKey.includes("License") ? this.defaultOffer.defaultPaymentTerm : ''
                    }
                }
                return '';
            },

            calculatedListPrice() {
                if (this.isENT && this.defaultOffer && this.defaultOffer.defaultPaymentTerm === 'year' && this.defaultOffer.offerKey.includes("License")) {
                    return (this.listPriceLocal).toFixed(2);
                } else if (this.isENT && this.defaultOffer && this.defaultOffer.defaultPaymentTerm === 'upfront' && this.defaultOffer.offerKey.includes("License")) {
                    return (this.listPriceLocal * 3).toFixed(2);
                } else {
                    return this.defaultOffer ? this.listPriceLocal.toFixed(2) : '';
                }
            },

            calculatedSalesPrice() {
                if(this.isPartnerAccount){
                    return this.salesPriceLocal.toFixed(2)
                }
                else if (this.isENT && this.defaultOffer && this.defaultOffer.defaultPaymentTerm === 'year' && this.defaultOffer.offerKey.includes("License")) {
                    return (this.salesPriceLocal * 12).toFixed(2);
                } else if (this.isENT && this.defaultOffer && this.defaultOffer.defaultPaymentTerm === 'upfront' && this.defaultOffer.offerKey.includes("License")) {
                    return (this.salesPriceLocal * 36).toFixed(2);
                } else {
                    return this.defaultOffer ? this.salesPriceLocal.toFixed(2) : '';
                }
            },
            hidePriceListingForVG(){
                if(this.isVGBasicCustomer && this.productKey === "VG54"){
                    return true;
                }
                return false;
            },
        },

        methods: {
            ...mapMutations([
                'setActiveProductFamily',
                'setActiveProductKey',
                'setActiveProductTab',
            ]),
            handleBuyButtonClick() {
                this.setActiveProduct(true); 
                this.trackBuyButtonClick();
            },
            handleInquireButtonClick(){
                if (this.isAnonymousCustomer){
                    this.$emit('anonymous-modal');
                    return 
                }
                this.$emit('inquire-modal', {'name': this.productInfo.name, 'key': this.productInfo.key});
            },

            trackBuyButtonClick() {
                const properties = {
                    buyButtonLocation: 'Home page',
                }
                this.fireSegmentTrackingWithSfdcSegments("Buy Button Clicked", this.sfdcSegments, properties);
            },

            setActiveProduct(buy) {
                this.displayLoader = true;
                this.setActiveProductKey(this.productKey);
                this.setActiveProductFamily(this.productFamily);
                
                // Set tab to buy automatically for accessories page
                if (!this.coreProducts.includes(this.activeProductKey)) {
                    this.setActiveProductTab('buy');
                } else if (buy) {
                    this.setActiveProductTab('buy');
                }

                // Handle vue store product speific module registration (if not instantiated already)
                if (!this.$store.getters[`${this.activeProductKey}/quantity`]) {
                    this.$store.registerModule(`${this.activeProductKey}`, product);
                }
                
                window.scrollTo(0, 0);
            },

            viewProduct(productKey) {
                const properties = {
                    productKey,
                    productName: this.productInfo.name,
                }
                this.fireSegmentTrackingWithSfdcSegments("Product Info Viewed", this.sfdcSegments, properties);
            },
        },
    }
</script>

<style scoped>
    .text-left {
        text-align: left;
    }

    @media (max-width: 736px) {
        .product-listing {
            text-align: center;
            cursor: pointer;
        }
        .product-brief {
            max-width: 75%;
            margin: 0 auto;
            margin-bottom: 5px;
        }
    }

    .product-listing {
        margin: 0 auto;
        -webkit-animation: fadeIn 1s;
        animation: fadeIn 1s;
        cursor: pointer;
    }

     /* Add animation (fade in the popup) */
    @-webkit-keyframes fadeIn {
        from {opacity: 0;}
        to {opacity: 1;}
        from {visibility: hidden;}
        to {visibility: visible;}
    }

    @keyframes fadeIn {
        from {opacity: 0;}
        to {opacity:1 ;}
        from {visibility: hidden;}
        to {visibility: visible;}
    }

    .product-name {
        font-weight: bold;
        font-size: 24px;
        line-height: 24px;
        color: #01263E;
    }

    .default-offer-list-price {
        -webkit-text-decoration-line: line-through; /* Safari */
        -webkit-text-decoration-color: #CD1426;
        -webkit-text-decoration-thickness: 2px;
        text-decoration-line: line-through;
        text-decoration-color: #CD1426;
        text-decoration-thickness: 2px;
        position: relative;
        font-size: 24px;
        line-height: 24px;
        color: #2E3438;
    }

    .default-offer-list-price::after {
        content: '';
        background: red;
        position: absolute;
        width: 100%;
        height: 2px;
        left: 0;
        top: 54%;
        transform: translate(0px,-50%);
    }

    .default-offer-sales-price {
        font-size: 24px;
        line-height: 24px;
        color: #2E3438;
    }

    .default-offer-payment-term {
        font-weight: lighter;
        font-size: 18px;
        color: #2E3438;
    }

    .product-brief {
        margin-top: 10px;
        font-size: 18px;
        line-height: 20px;
        padding-bottom: 5px;
    }

    .view-product {
        color: #0D6EDE;
        align-items: center;
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        cursor: pointer;
        padding-left: 0px;
        display: block;
        margin-right: 20px;
    }

    .view-product:hover {
        -webkit-text-decoration-line: underline;
        text-decoration-line: underline;
    }

    .buy-product {
        color: #0D6EDE;
        align-items: center;
        font-style: normal;
        font-weight: 800;
        font-size: 20px;
        cursor: pointer;
        padding-left: 0px;
        display: block;
    }

    .buy-product:hover {
        -webkit-text-decoration-line: underline;
        text-decoration-line: underline;
    }

    .small-fleet-list-price{
        -webkit-text-decoration-line: line-through; /* Safari */
        -webkit-text-decoration-color: #CD1426;
        -webkit-text-decoration-thickness: 2px;
        text-decoration-line: line-through;
        text-decoration-color: #CD1426;
        text-decoration-thickness: 2px;
        position: relative;
        font-size: 24px;
        line-height: 24px;
        color: #0184FB;
        font-weight: bold;
    }
    .small-fleet-sale-price{
        font-size: 24px;
        line-height: 24px;
        color: #0184FB;
        font-weight: bold;
    }
    .small-fleet-payment-terms{
        color:black;
        font-size: 18px;
    }
</style>
